import React from "react";
import GraphSettingsController from "../components/network/GraphSettingsController";
import SubNetworkDataController from "../components/subnetwork/SubNetworkDataController";

import "../css/network.css";
import SubNetworkEventsController from "../components/subnetwork/SubNetworkEventsController";
import SubNetworkLegendHighlightController from "../components/subnetwork/SubNetworkLegendHighlightController";
import SubNetworkUserInterface from "../components/subnetwork/SubNetworkUserInterface";
import WithWebGL from "../components/WithWebGL";
import {SubNetworkProvider} from "../contexts/SubNetworkContext";
import {usePageTitle} from "../hooks/usePageTitle";
import SigmaProvider from "../utils/sigmaProvider";


const Subnetwork = () => {
  usePageTitle("Subnetwork View");

  return (
    <WithWebGL>
      <SubNetworkProvider>
        <SigmaProvider>
          <GraphSettingsController/>
          <SubNetworkEventsController/>
          <SubNetworkLegendHighlightController/>
          <SubNetworkDataController/>

          <SubNetworkUserInterface/>
        </SigmaProvider>
      </SubNetworkProvider>
    </WithWebGL>
  );
};

export default React.memo(Subnetwork);
